import { Injectable } from '@angular/core';
import { Parada } from '@tivic-team/manager-ts/dist/mob/entities/parada/parada.entity';
import { ParadaColetivoRuralDTO } from 'app/model/dtos/mob/parada-coletivo-rural.dto';
import { ParadaColetivoUrbanoDTO } from 'app/model/dtos/mob/parada-coletivo-urbano.dto';
import { ParadaDTO } from 'app/model/dtos/mob/parada.dto';
import { HttpDelete, HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environment } from 'src/environments/environment';
import { environmentv3 } from 'src/environments/environmentv3';
@Injectable()
export class ParadaController {

    constructor() { }
    
    async getByGrupo(cdGrupoParada: number):Promise<Array<Parada>>{
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/paradas/taxis/:cdGrupoParada',
					environment: environment,
					pathParams: new JSONData({cdGrupoParada: cdGrupoParada})
				}),
			}),
			new HttpResponse(
				new Array<Parada>()
			)
		);
		return await quark.call();
	}

	async findTaxis(filtros?: IFilter): Promise<Array<Parada>>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/taxiparada',
                    environment: environment,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new Array<Parada>()
            )
        );

        return await quark.call();
    }

    async create(paradaDTO: ParadaDTO): Promise<ParadaDTO>{
        let quark= new Quark(
            new HttpPost({
                url: new Url({
                    id: 'mob/paradas',
                    environment: environment
                }),
                data: new JSONData(paradaDTO)
            }),

            new HttpResponse(
                new ParadaDTO()
            )
        );

        return await quark.call();
    }

    async getTaxis (cdParada: number): Promise<ParadaDTO>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/paradas/taxis/parada/:cdParada',
                    environment: environment,
                    pathParams: new JSONData({ cdParada: cdParada})
                }),
            }),
            new HttpResponse(
                new ParadaDTO()
            )
        );

        return await quark.call();
    }

    find(filters ? : IFilter): Promise <ParadaColetivoUrbanoDTO[]> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/parada',
                    environment: environmentv3,
                    filter: filters,
                }),
            }),
            new HttpResponse(new Array<ParadaColetivoUrbanoDTO>())
        );

        return request.call();
    }

    findColetivoRural(filters ? : IFilter): Promise <ParadaColetivoRuralDTO[]> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/parada/coletivo-rural',
                    environment: environmentv3,
                    filter: filters,
                }),
            }),
            new HttpResponse(new Array<ParadaColetivoRuralDTO>())
        );

        return request.call();
    }

    async update(paradaDTO: ParadaDTO): Promise<ParadaDTO>{
        let quark = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/paradas/:cdParada',
                    environment: environment,
                    pathParams: new JSONData({ cdParada: paradaDTO.parada.cdParada})
            }),

            data: new JSONData(paradaDTO)
            }),
            new HttpResponse(
                new Parada()
            )
        );

        return await quark.call();
    }
    
	async get(cdParada: number): Promise<ParadaDTO> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/paradas/:cdParada',
					environment: environment,
					pathParams: new JSONData({ cdParada })
				}),
			}),
			new HttpResponse(
				new ParadaDTO()
			)
		);
		return await quark.call();
	}

    async remove(cdParada: number): Promise<Parada> {
		let quark = new Quark(
			new HttpDelete({
				url: new Url({
					id: 'mob/parada/:cdParada',
					environment: environmentv3,
					pathParams: new JSONData({ cdParada })
				}),
			}),
			new HttpResponse(
				new Parada()
			)
		);
		return await quark.call();
	}
}  